<template>
    <ui5-dialog id="add-order-line-dialog" ref="addOrderLineDialog">
        <div id="add-order-line-dialog-inner">
            <add-order-line
                @finished="onFinished"
                :profile-id-param="profileIdParam"
                :product-id-param="productIdParam"></add-order-line>
        </div>
    </ui5-dialog>
</template>
<script>
import AddOrderLine from './AddOrderLine';
export default {
    components: { AddOrderLine },
    props: ['profileIdParam', 'productIdParam'],
    methods: {
        onFinished(isCancel) {
            this.closePopup();
        },
        showPopup() {
            this.$refs.addOrderLineDialog.show();
        },
        closePopup() {
            this.$refs.addOrderLineDialog.close();
        },
    },
};
</script>
